import { api } from "./client";

export interface ModelInfo {
  id: string;
  label: string;
  context_window: number;
  is_default?: boolean;
  description?: string | null;
}

export interface ProviderInfo {
  id: string;
  label: string;
  type: "local" | "cloud";
  available: boolean;
  available_reason: string | null;
  supports_tools: boolean;
  is_default: boolean;
  models: ModelInfo[];
}

export interface ProvidersResponse {
  default_provider: string;
  default_model: string;
  providers: ProviderInfo[];
}

export interface LLMTestResponse {
  ok: boolean;
  provider: string;
  model: string | null;
  text: string;
  duration_ms: number;
  input_tokens: number | null;
  output_tokens: number | null;
  error: string | null;
}

export const llmApi = {
  listProviders: () => api.get<ProvidersResponse>("/api/v1/llm/providers"),
  /** Doc 57: admin verify API key works without going to chat. */
  testProvider: (
    provider: "anthropic" | "openai" | "google" | "deepseek" | "ollama",
    options?: { prompt?: string; model?: string },
  ) =>
    api.post<LLMTestResponse>("/api/v1/admin/llm/test", {
      provider,
      prompt: options?.prompt ?? "Say 'OK' in 1 word.",
      model: options?.model,
      max_tokens: 50,
    }),
};
